import {
  sendRequest,
  sendGoogleEvent,
  isElementOnScreen,
  byWindowAction,
} from '@html/_common/utils';

export default function initiateVideos(mobileWidth, tourId, tourName) {
  const videoName = `${tourName} - ${$('.js-ao-tour-videos__choose-button--active').text()}`;

  const loadVimeoImage = (vimeoId) => {
    if (!$(`.js-ao-tour-videos__preview-image[data-vimeo="${vimeoId}"]`).hasClass('done')) {
      sendRequest(`//vimeo.com/api/v2/video/${vimeoId}.json?callback=?`, {}, (data) => {
        $(`.js-ao-tour-videos__preview-image[data-vimeo="${data[0].id}"]`).attr('src', data[0].thumbnail_large).addClass('done');
      });
    }
  };

  if ($(window).width() <= mobileWidth && $('.js-ao-tour-videos__video').length) {
    $('.js-ao-tour-videos__video').height(($('.js-ao-tour-videos__video').width() / 16) * 9);
  }

  $('.js-ao-tour-videos__preview-image').click((event) => {
    event.preventDefault();
    $(event.currentTarget).parent().find('.js-ao-tour-videos__play').click();
  });

  $('.js-ao-tour-videos__play').click(() => {
    const videoId = $('.js-ao-tour-videos__video').data('id');
    if (!$(`#video-${videoId}`).length) {
      $('.js-ao-tour-videos__play').hide();

      sendRequest('/api/tour/load', {
        action: 'loadVideo',
        id: tourId,
        videoId,
      }, (data) => {
        if (data && data.status === 'OK') {
          $('.js-ao-tour-videos__preview-image').addClass('ao-tour-videos__preview-image--hidden');
          const $video = $('.js-ao-tour-videos__video');
          if (data.component.type === 'youtube') {
            const $youtubeVideo = $('<iframe>', {
              src: `//www.youtube-nocookie.com/embed/${data.component.videoId}?rel=0&autoplay=1&mute=1&controls=1&showinfo=0`,
              id: `video${videoId}`,
              frameborder: 0,
              allowfullscreen: true,
              scrolling: 'no',
            });

            $youtubeVideo.appendTo($video);
            $youtubeVideo.width($video.width());
            $youtubeVideo.height($video.height());
          } else if (data.component.type === 'vimeo') {
            const $vimeoVideo = $('<iframe>', {
              src: `//player.vimeo.com/video/${data.component.videoId}?autoplay=1&badge=0&title=0`,
              id: `video${videoId}`,
              frameborder: 0,
              allowfullscreen: true,
              webkitAllowFullScreen: true,
              mozallowfullscreen: true,
              scrolling: 'no',
            });

            $vimeoVideo.appendTo($video);
            $vimeoVideo.width($video.width());
            $vimeoVideo.height($video.height());
          }

          sendGoogleEvent(
            'Video Click',
            'Play',
            videoName,
            {
              ampEventName: 'tdp_video_clicked',
              tdp_video_clicked_play: 'Yes',
            },
          );
        }
      });
    }
  });

  $('.js-ao-tour-videos__choose-button').click((event) => {
    const $clickedElement = $(event.currentTarget);
    const videoId = $clickedElement.data('id');

    $('.js-ao-tour-videos__choose-button').removeClass('ao-tour-videos__choose-button--active');
    $clickedElement.addClass('ao-tour-videos__choose-button--active');
    $('.js-ao-tour-videos__play').show();

    const $video = $('.js-ao-tour-videos__video');
    $video.removeClass('ao-tour-videos__video--pending');
    $video.data('id', videoId);

    $('.js-ao-tour-videos iframe').remove();

    if ($(`.js-ao-tour-videos__preview-image[data-id="${videoId}"]`).length) {
      $('.js-ao-tour-videos__preview-image').addClass('ao-tour-videos__preview-image--hidden');
      $(`.js-ao-tour-videos__preview-image[data-id="${videoId}"]`).removeClass('ao-tour-videos__preview-image--hidden');
    } else {
      $video.addClass('ao-tour-videos__video--pending');

      sendRequest('/api/tour/load', {
        action: 'loadVideo',
        id: tourId,
        videoId,
      }, (data) => {
        if (data && data.status === 'OK') {
          if (data.component.type === 'youtube') {
            $('.js-ao-tour-videos__preview-image').last().after(`<img class="ao-tour-videos__preview-image js-ao-tour-videos__preview-image" src="${data.component.image}" data-id="${data.component.id}"/>`);
          } else if (data.component.type === 'vimeo') {
            $('.js-ao-tour-videos__preview-image').last().after(`<img class="ao-tour-videos__preview-image js-ao-tour-videos__preview-image js-ao-tour-videos__vimeo" data-vimeo="${data.component.videoId}" src="" data-id="${data.component.id}"/>`);
            loadVimeoImage(data.component.videoId);
          }
          $video.removeClass('ao-tour-videos__video--pending');
          $('.js-ao-tour-videos__preview-image').addClass('ao-tour-videos__preview-image--hidden');
          $(`.js-ao-tour-videos__preview-image[data-id="${videoId}"]`).removeClass('ao-tour-videos__preview-image--hidden');
        }
      });
    }

    sendGoogleEvent(
      'Video Click',
      'Change Video',
      videoName,
      {
        ampEventName: 'tdp_video_clicked',
        tdp_video_clicked_changed: videoName,
      },
    );
  });

  $(window).resize(() => {
    $('.js-ao-tour-videos iframe, .js-ao-tour-videos__video').height(($('.js-ao-tour-videos__video').width() / 16) * 9);
  });

  if ($('.js-ao-tour-videos__preview-image.js-ao-tour-videos__vimeo').length) {
    if (isElementOnScreen($('.js-ao-tour-videos'), 0)) {
      loadVimeoImage($('.js-ao-tour-videos__preview-image.js-ao-tour-videos__vimeo').data('vimeo'));
    }
    byWindowAction(['scroll'], () => {
      if (isElementOnScreen($('.js-ao-tour-videos'), 0)) {
        loadVimeoImage($('.js-ao-tour-videos__preview-image.js-ao-tour-videos__vimeo').data('vimeo'));
      }
    });
  }
}
